// const CnTextRegexp = /[\u0391-\uFFE5￥！？…、，；。‘’“”（）《》【】]/g

const DateFormat = (format, date) => {
  if (!date) {
      date = new Date();
  }
  let o = {
      "y+": date.getYear(),
      "M+": date.getMonth() + 1, 
      "d+": date.getDate(),
      "h+": date.getHours(),
      "H+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      "S": date.getMilliseconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(/(y+)/g, $1 => {
      return `${date.getFullYear()}`.slice(-$1.length)
    })
  } 
  for(let i in o) {
    format = format.replace(new RegExp(`${i}`), $1 => {
      return `0${o[i]}`.slice(-$1.length)
    })
  }
  return format;
}

const getTextLength = text => {
  return formatString(`${text}`).replace(/[\u0391-\uFFE5]/g, '--').length
}

const formatString = text => {
  return text.trim()
}

const buildUrlParam = (url) => {
  let res = {}
  url.replace(/([^\=\&]+)=([^\=\&]+)/g, (x, k, y) => {
    res[k] = y
    return x
  })
  return res
}

const S4 = () => {
  (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

const createUniqueId = () => {
  return `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`
}

const setUpdateContentPrice = (form) => {
  let { CONTROL_PRICE, PROVISIONAL_SUM, TEMPORARY_VALUATION, MATERIAL_FEE} = form
  form.updateContent_price = {
    CONTROL_PRICE, PROVISIONAL_SUM, TEMPORARY_VALUATION, MATERIAL_FEE
  }
}

const deleteSpecialKeys = (form) => {
  let keys = [
    TENDER_CODE, TENDER_SCHEDULE, updateContent_time, 
    InviteEnterprises, updateContent_InviteEnterprises
  ]
  keys.forEach(key => {
    delete form[key]
  })
}

const copy = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

export default {
  DateFormat,
  getTextLength,
  formatString,
  buildUrlParam,
  createUniqueId,
  setUpdateContentPrice,
  deleteSpecialKeys,
  copy
}